export default {
    path: "/financeDashboard",
    meta: { label: "Finance Dashboard" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            meta: {
                requiresAuth: true,
            },
            component: () => import("@/views/finance/Dashboard.vue"),
        },
    ],
};